const COLORS = [
    "#a59647",
    "#30321d",
    "#1f2af0",
    "#c79e59",
    "#b647bc",
    "#dcc7f5",
    "#25874f",
    "#e88b21",
    "#6cb55d",
    "#00b16e",
    "#7dab44",
    "#692f83",
    "#397cf6",
    "#496842",
    "#5f0071",
    "#28a7ff",
    "#407a7c",
    "#9c8e7a",
    "#05e5ec",
    "#079791",
    "#ab47dc",
    "#e5fe51",
    "#7731a0",
    "#35adce",
    "#bee099",
    "#565b9d",
    "#b97095",
    "#10ae28",
    "#fe4e76",
    "#85c424",
    "#b092e3",
    "#e8e74d",
    "#d11d4d",
    "#a2e24d",
    "#f6af5c",
    "#de72f8",
    "#01dbc7",
    "#d01b30",
    "#18bf60",
    "#229e09",
    "#4cddf9",
    "#e1c906",
    "#a6e1a1",
    "#2f0932",
    "#803663",
    "#b67dfc",
    "#80837c",
    "#75b217",
    "#5edc51",
    "#5b8f23",
    "#1439dc",
    "#b5bb64",
    "#3a2cdc",
    "#a2b7b5",
    "#59c353",
    "#568a2a",
    "#c0e791",
    "#b5c4f7",
    "#2c0a4a",
    "#f02893",
    "#57a93d",
    "#17d6f9",
    "#65e15d",
    "#2badd9",
    "#dc7202",
    "#f64bb7",
    "#7c3a6e",
    "#72399f",
    "#993e86",
    "#088210",
    "#a020e3",
    "#d9f495",
    "#75c9d4",
    "#8041fc",
    "#b56d67",
    "#db6798",
    "#1334f8",
    "#8a36a9",
    "#429e0c",
    "#134611",
    "#1b0d6a",
    "#86e86a",
    "#2c8b2c",
    "#8b5800",
    "#b46d5f",
    "#adf4a0",
    "#e4b929",
    "#4bb150",
    "#e99084",
    "#36655e",
    "#b73208",
    "#fc6825",
    "#019770",
    "#533a53",
    "#d8e912",
    "#03b9e5",
    "#e40df0",
    "#78b9d3",
    "#2626c3",
    "#6d3dce",
    "#92d843",
    "#c800ee",
    "#38bfb1",
    "#b98ab6",
    "#77cf5c",
    "#f35925",
    "#1e7a17",
    "#f7007b",
    "#f1180b",
    "#d1698d",
    "#3e0b54",
    "#8f87e5",
];

export default COLORS;
